import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import { useHistory, useRouteMatch } from "react-router-dom";
// import useDialog from "../../hooks/use-dialog";

type ContentProps = {
  label?: string;
  text?: string;
};

type ApproachProps = {
  data: ContentProps[];
  type?: string;
  header?: string;
  content?: string;
  text?: string;
};

const InstituteApproachSection = (props: ApproachProps) => {
  // let history = useHistory();

  // const handleClickOpen = () => {
  //   history.push(`/employers`);
  // };

  // const {
  //   openDialog: open,
  //   handleOpenDialog: handleOpen,
  //   handleCloseDialog,
  // } = useDialog();

  // const handleClose = () => {
  //   handleCloseDialog();
  // };

  let headerSize = props.type === "subtitle" ? "20px" : "50px";

  return (
    <React.Fragment>
      <Box className="pt-10">
        <Box className="items-center place-content-center ">
          <Typography
            variant={`${props.type === "subtitle" ? "subtitle1" : "h1"}`}
            width={{ xs: "90%", md: "65%" }}
            fontSize={{ xs: "30px", sm: "40px", md: headerSize }}
            lineHeight={"120.5%"}
            letterSpacing={"-0.04em"}
            mx="auto"
            className="py-8  text-center"
          >
            {props.header}
          </Typography>
          <Typography
            variant="caption"
            color="primary.main"
            width={{ xs: "90%", md: "70%" }}
            fontSize="13px"
            lineHeight="185%"
            letterSpacing="0.02em"
            align="center"
            mx="auto"
            paragraph
          >
            {props.text}
          </Typography>
          <Typography
            variant="body1"
            color="primary.main"
            width={{ xs: "90%", md: "70%" }}
            fontSize="13px"
            lineHeight="185%"
            letterSpacing="0.02em"
            align="center"
            mx="auto"
            paragraph
          >
            {props.content}
          </Typography>

          {/* Web */}

          <Box
            className="hidden md:grid grid-cols-3 items-start mx-auto text-center"
            justifyContent="center"
          >
            {props.data.map((item, index) => (
              <Box className="ml-8 mr-8 py-8">
                <Typography
                  variant="subtitle1"
                  fontSize={{ xs: "12px", sm: "14px" }}
                  lineHeight={"102%"}
                  letterSpacing={"0.1em"}
                  className="uppercase text-center"
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body1"
                  fontSize={{ xs: "12px", sm: "14px", md: "15px" }}
                  lineHeight={"150%"}
                  letterSpacing={"0.02em"}
                  className="py-4  text-center  "
                >
                  {item.text}
                </Typography>
              </Box>
            ))}
            {/* &bull; */}
          </Box>

          {/* Mobile */}

          <Box className="md:hidden block items-start place-content-center mx-auto text-center">
            {props.data.map((item, index) => (
              <Box className="ml-8 mr-8 py-8">
                <Typography
                  variant="subtitle1"
                  fontSize={{ xs: "12px", sm: "14px" }}
                  lineHeight={"102%"}
                  letterSpacing={"0.1em"}
                  className="uppercase text-center"
                >
                  {item.label}
                </Typography>
                <Typography
                  variant="body1"
                  fontSize={{ xs: "12px", sm: "14px", md: "15px" }}
                  lineHeight={"150%"}
                  letterSpacing={"0.02em"}
                  className="py-4  text-center  "
                >
                  {item.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <hr className="hidden md:block w-[90%] mx-auto h-0 border-t-lilac-300 mt-10" />
      </Box>
    </React.Fragment>
  );
};

export default InstituteApproachSection;
